"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initializeInboxRulesEditState_1 = require("../actions/helpers/initializeInboxRulesEditState");
var mobx_1 = require("mobx");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('inboxRulesOption', {
    inboxRulesListState: {
        inboxRules: mobx_1.map({}),
        inboxRuleIds: [],
        getInboxRuleRequestStatus: 0 /* NotInitiated */,
        getInboxRuleDiagnosticRequestStatus: 0 /* NotInitiated */,
        hasLoggedGetInboxRulesInformation: false,
    },
    inboxRulesEditState: initializeInboxRulesEditState_1.default(),
    findFoldersRequestStatus: 0 /* NotInitiated */,
    dropdownFolders: [],
    junkFolderDisplayName: '',
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/store/store.js
// module id = 2603
// module chunks = 2 90